import type { ShopperSearch } from '@/scapi';

/** SCAPI attribute id for the event/course venue facet (BM: eventVenueName). */
export const VENUE_FACET_ATTRIBUTE_ID = 'c_eventVenueName';

type ProductSearchRefinement = ShopperSearch.schemas['ProductSearchRefinement'];

export function findVenueRefinement(
    refinements: ProductSearchRefinement[] | undefined
): ProductSearchRefinement | undefined {
    return refinements?.find((r) => r.attributeId === VENUE_FACET_ATTRIBUTE_ID);
}

/** True when the venue facet is configured and has at least one value. */
export function hasVenueFacetRefinement(refinements: ProductSearchRefinement[] | undefined): boolean {
    const venue = findVenueRefinement(refinements);
    return Boolean(venue && (venue.values?.length ?? 0) > 0);
}

export function getActiveVenueValue(refines: string[]): string | null {
    const prefix = `${VENUE_FACET_ATTRIBUTE_ID}=`;
    for (const refine of refines) {
        if (refine.startsWith(prefix)) {
            const value = refine.slice(prefix.length);
            return value || null;
        }
    }
    return null;
}

export function hasActiveVenueFacet(refines: string[]): boolean {
    return getActiveVenueValue(refines) != null;
}

/**
 * Strip existing venue refine pairs, then optionally append a single value.
 * Pass `null` to clear the venue facet only.
 */
export function replaceVenueRefine(currentRefines: string[], value: string | null): string[] {
    const prefix = `${VENUE_FACET_ATTRIBUTE_ID}=`;
    const withoutVenue = currentRefines.filter((r) => !r.startsWith(prefix));
    if (!value) {
        return withoutVenue;
    }
    return [...withoutVenue, `${VENUE_FACET_ATTRIBUTE_ID}=${value}`];
}
